export type AppLanguage = "en" | "cs" | "cimode";
export const languages: AppLanguage[] = ["en", "cs"];

export const languagesWithCImode: AppLanguage[] = ["en", "cs", "cimode"];
